@use "../../variables" as *;

.image-container {
  position: relative;

  .tag,
  .like {
    position: absolute;
    bottom: 1rem;
  }

  .tag {
    left: 0;

    &.saleTag {
      bottom: 0.563rem;
    }
  }

  .like {
    right: 1rem;

    &.fill span {
      fill: $ny-red;
    }
  }
}